import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const news = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        NEWS_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        NEWS_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        NEWS_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        NEWS_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        NEWS_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        NEWS_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        NEWS_REMOVE_ITEM(state, item) {
            console.log("removeeeee", state.items)
            console.log("itemmmmm", item)
            const index = state.items.findIndex(i => i.id === item.id);
            console.log("indexxx", index)
            state.items.splice(index, 1);
        }
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }, { page, itemsPerPage, filter }) {
            console.log("get place store filter", filter)
            let body = {
                pageNumber: page,
                pagesize: itemsPerPage,
                sortField: "Date",
                sortOrder: -1,
                searchCriteria: 
                {
                    cityCode: authstore.getters.jwtDecoded(authstore.state).city_code,
                    "isArchived": true
                },
            }

            console.log("store getitems before")

            await clients.placeServiceClient.searchNews(body)
                .then((res) => res.data)
                .then((data) =>{
                    console.log(data);
                    commit('NEWS_SET_ITEMS', data);
                }
                    
                    
                )
            console.log("store getitems after")

        },
        async create({ commit }, news) {
            console.log("News Create is called.")
            console.log(news)
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            console.log("JWT",jwt);
            let body = {
                cityCode: jwt.city_code,
                title: news.title,
                text: news.text,
                date: news.date,
            }
            console.log("Body of the request is:",  body)
            console.log("Before News Create Request")
            await clients.placeServiceClient.addNews(body);
            console.log("After News Create Request")
            //commit('PLACE_CREATE_ITEM', body);
        },
        async update({ commit }, news) {
            console.log("News update is called.")
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                "cityCode": jwt.city_code,
                "title": news.title,
                "text": news.text,
                "date": news.date,
                "id": news.id,
                "isArchived": news.isArchived,
                "files": []
            }
            console.log("Before News Update Call")
            await clients.placeServiceClient.updateNews(body);
            console.log("After News Update Call")
            
        },
        async remove({ commit }, news) {
            console.log("newsID", news.item.id)
            await clients.placeServiceClient.deleteNews(news.item.id);
            commit('NEWS_REMOVE_ITEM', news.item);
        },

        async archiveNews({ commit }, newsId) {
            console.log("Archive News Object ID", newsId);
            await clients.placeServiceClient.archiveNews(newsId);
        },

        async unarchiveNews({ commit }, newsId) {
            console.log("Unarchive News Object ID", newsId)
            await clients.placeServiceClient.unarchiveNews(newsId);
        },

        async uploadNewsAsset({ commit }, news) {
            console.log("upppppppppload", news.id)
            console.log("upppppppppload", news.file)
            let file = {
                data: news.file,
                fileName: news.file.name
            }
            await clients.placeServiceClient.uploadNewsAsset(news.id, file);
        },

        async removeNewsAsset({ commit }, news) {
            console.log(news)
            console.log(news.newsId, news.assetId)
            await clients.placeServiceClient.deleteNewsAsset(news.newsId, news.assetId);
        },
        
    }
}

export default news;